import React, { useMemo } from 'react';
import { Card, Space, Tag } from 'antd';
import { useAndStore } from '../../base/store/useAndStore';
import { getDataSetStoreKey } from '../../base/storeKeyUtils';
import { createCommand } from '../../base/actionParser';
import type { BaseComponentProps, DataSetConfig } from '../../types/common';

interface ProductItem {
  id: string | number;
  name: string;
  image?: string;
  price?: number;
  originalPrice?: number;
  tags?: string[];
}

export interface AndProductCategoryProps extends BaseComponentProps, DataSetConfig {
  /** 商品列表 */
  products?: ProductItem[];
  /** 列数 */
  columns?: number;
  /** 点击动作 */
  clickAction?: string;
  /** 容器样式 */
  style?: React.CSSProperties;
}

export const AndProductCategory: React.FC<AndProductCategoryProps> = ({
  id, sessionId, develop, dataSet, dataSetField, products: propProducts, columns = 4, clickAction, style
}) => {
  const addCommand = useAndStore((state) => state.addCommand);
  const getDataSet = useAndStore((state) => state.getDataSet);
  const dataSetKey = useMemo(
    () => getDataSetStoreKey(sessionId, dataSet),
    [sessionId, dataSet]
  );

  const storeProducts = useMemo(() => {
    if (dataSetKey && dataSetField) {
      const data = getDataSet(dataSetKey, dataSetField);
      return Array.isArray(data) ? data : [];
    }
    return [];
  }, [dataSetKey, dataSetField, getDataSet]);

  const products = storeProducts.length > 0 ? storeProducts : (propProducts || []);

  const handleClick = (product: ProductItem) => {
    if (clickAction && sessionId) {
      addCommand(sessionId, createCommand(clickAction, product));
    }
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: 16, ...style }}>
      {products.map((product) => (
        <Card
          key={product.id}
          hoverable
          cover={product.image && <img alt={product.name} src={product.image} style={{ height: 200, objectFit: 'cover' }} />}
          onClick={() => handleClick(product)}
        >
          <Card.Meta
            title={product.name}
            description={
              <Space direction="vertical" size={4}>
                {product.price !== undefined && (
                  <div>
                    <span style={{ color: '#f5222d', fontSize: 18, fontWeight: 'bold' }}>¥{product.price}</span>
                    {product.originalPrice && (
                      <span style={{ marginLeft: 8, color: '#999', textDecoration: 'line-through' }}>¥{product.originalPrice}</span>
                    )}
                  </div>
                )}
                {product.tags && product.tags.length > 0 && (
                  <Space size={4} wrap>
                    {product.tags.map((tag: any, idx: any) => (
                      <Tag key={idx} color="blue">{tag}</Tag>
                    ))}
                  </Space>
                )}
              </Space>
            }
          />
        </Card>
      ))}
    </div>
  );
};

export default AndProductCategory;
